import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { environment } from '../../../environments/environment';
import { CookieService } from "ngx-cookie-service";
import { AuthService } from '../../auth/auth.service';
import { decodeBase64ToText, encodeToBase64 } from '../../utility';
import { ApiService } from '../../api.service';
import { HelperService } from '../../shared/services/helper.service';
import { HttpService } from '../../shared/services/http.service';
import { ToastService } from '../../shared/services/toast.service';

@Component({
  selector: 'app-admin-header',
  templateUrl: './admin-header.component.html',
  styleUrl: './admin-header.component.css'
})
export class AdminHeaderComponent implements OnInit {
  env = environment;
  items: MenuItem[] | undefined;
  iconItems: MenuItem[] | undefined;
  selectedCategory: any = null;
  userInfo: any;
  profilePic: any;
  helper = inject(HelperService);
  httpService = inject(HttpService);
  toastService = inject(ToastService);
  authService = inject(AuthService);
  // categories: any[] = [
  //   { name: 'Affiliate', key: 'A' },
  //   { name: 'OBP Manager', key: 'M' },
  //   { name: 'Oncology Lead', key: 'P' }
  // ];

  categories: any[] = [
    { name: 'Admin', key: 'admin' },
    { name: 'Affiliate', key: 'affiliate' },
    { name: 'IEL', key: 'iel' },
    { name: 'Lead', key: 'lead' },
    { name: 'Default', key: 'member' }
  ];

  
  private readonly auth=inject(AuthService);
  private readonly router=inject(Router);
  private readonly apiService= inject(ApiService);


  ngOnInit(): void {
    this.items = [
      {
        label: 'Timelines',
        route: '/admin/timelines'
      },
      {
        label: 'Groups',
        route: '/admin/groups'
      },
      {
        label: 'Users',
        route: '/admin/users'
      },
      {
        label: 'Business Themes',
        route: '/admin/business'
      },
      {
        label: 'Outcomes',
        route: '/admin/outcomes'
      },
      {
        label: 'WP Approval Requests',
        route: '/admin/wp-approval'
      },
    ];

    this.selectedCategory = this.categories[0];
    this.userInfo = JSON.parse(decodeBase64ToText(this.auth.getCookie()));
    this.profilePic=this.userInfo?.data?.avatar;
  }

  get getUserName() {
    return this.userInfo?.data?.name;  // "Sumit Chauhan"
  }

  get getUserDesignation() {
    return this.userInfo?.data?.designation;  // "Sumit Chauhan"
  }

  
  selectDesignation(value: any) {
    if (value.name == 'Admin') {
      this.router.navigate(['/admin/timelines']);
    } else {
      this.router.navigate(['/home']);
      this.apiService.setRole(value['key']);
    }
  }

  

  logOut() {
    this.httpService
      .get(`${environment.opbBackendHost}/api/auth/logout`)
      .subscribe((response: any) => {
        if (response) {
          this.toastService.success(response?.message);
          this.authService.logOut();
          this.router.navigate(['/']);
        }
      });
  }

}
